import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import React from 'react'
import { ItemContainer } from '../../Toolbar/Items/Item'

export class Orientation extends Component {

    static propTypes = {
        switchToPortraitOrientation: PropTypes.func.isRequired,
        switchToLandscapeOrientation: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
        isLandscapeOrientation: PropTypes.bool.isRequired,
    }

    render() {
        const { t, switchToPortraitOrientation, switchToLandscapeOrientation, isLandscapeOrientation } = this.props

        return (
            <div className="print-orientation-wrapper">
                <span className="title">{t("visualizer:toolbar.left.print.preview.orientation.title")}</span>
                <div className="orientation-option-wrapper">
                    <div className="orientation-option">
                        <div>
                            <ItemContainer
                                name={"portrait"}
                                action={switchToPortraitOrientation}
                                icon={"nf nf-portrait nf-2x"}
                                isSelected={! isLandscapeOrientation}
                            />
                            <span className="label">{t("visualizer:toolbar.left.print.preview.orientation.portrait")}</span>
                        </div>
                    </div>
                    <div className="orientation-option">
                        <div>
                            <ItemContainer
                                name={"landscape"}
                                action={switchToLandscapeOrientation}
                                icon={"nf nf-landscape nf-2x"}
                                isSelected={isLandscapeOrientation}
                            />
                            <span className="label">{t("visualizer:toolbar.left.print.preview.orientation.landscape")}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(Orientation)
